import React, { useState } from "react";
import FixaSearch from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";
import { Article } from "../types/article";
import { useTranslation } from "@coworker/locales";
import { includesCaseInsensitive, removeAccents } from "../../../helpers/utils";

interface SearchBarProps<A extends Article> {
  articles: A[];
  onSearchResults: (isSearchResult: boolean, results: A[]) => void;
}

export const SearchBar = <A extends Article>({
  articles,
  onSearchResults,
}: SearchBarProps<A>) => {
  const [searchInput, setSearchInput] = useState("");
  const { t } = useTranslation();

  const handleSearch = (value: string) => {
    const sanitizedValue: string = removeAccents(value.replace(/[.,\s]/g, ""));
    setSearchInput(value);

    if (!articles) return;

    onSearchResults(
      !!sanitizedValue,
      articles.filter(
        (article) =>
          includesCaseInsensitive(
            removeAccents(article.itemName),
            sanitizedValue
          ) ||
          includesCaseInsensitive(
            removeAccents(article.itemType),
            sanitizedValue
          ) ||
          includesCaseInsensitive(
            removeAccents(article.itemColor),
            sanitizedValue
          ) ||
          includesCaseInsensitive(
            removeAccents(article.productArticleId),
            sanitizedValue
          )
      )
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(e.target.value);
  };

  const handleClear = () => {
    handleSearch("");
  };

  return (
    <FixaSearch
      id="article-search"
      value={searchInput}
      onChange={handleChange}
      onClear={handleClear}
      placeholder={t("searchBasicString")}
      data-testid="article-search-testid"
    />
  );
};
